'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ID = exports.ID = ['id'];
var TYPE = exports.TYPE = ['type'];
var CAPTURE_VISITOR_EMAIL_ADDRESS = exports.CAPTURE_VISITOR_EMAIL_ADDRESS = ['captureVisitorEmailAddress'];
var CUSTOM_EMAIL_CAPTURE_DELAY = exports.CUSTOM_EMAIL_CAPTURE_DELAY = ['customEmailCaptureDelay'];
var INBOX_ID = exports.INBOX_ID = ['inboxId'];
var ROUTING_RULES = exports.ROUTING_RULES = ['routingRules'];
var SEND_FROM_ROUTING_RULES = exports.SEND_FROM_ROUTING_RULES = ['sendFromRoutingRules'];
var TARGETING_RULES = exports.TARGETING_RULES = ['targetingRules'];
var GDPR_EXPLICIT_CONSENT_REQUIRED = exports.GDPR_EXPLICIT_CONSENT_REQUIRED = ['gdprExplicitConsentRequired'];
var GDPR_CONSENT_TO_PROCESS_ENABLED = exports.GDPR_CONSENT_TO_PROCESS_ENABLED = ['gdprConsentToProcessEnabled'];
var GDPR_CONSENT_TO_COMMUNICATE_ENABLED = exports.GDPR_CONSENT_TO_COMMUNICATE_ENABLED = ['gdprConsentToCommunicateEnabled'];
var CUSTOM_CONSENT_TO_PROCESS_MESSAGE = exports.CUSTOM_CONSENT_TO_PROCESS_MESSAGE = ['customConsentToProcessMessage'];
var CUSTOM_CONSENT_TO_COMMUNICATE_MESSAGE = exports.CUSTOM_CONSENT_TO_COMMUNICATE_MESSAGE = ['customConsentToCommunicateMessage'];
var CONSENT_TO_COMMUNICATE_SUBSCRIPTION_ID = exports.CONSENT_TO_COMMUNICATE_SUBSCRIPTION_ID = ['consentToCommunicateSubscriptionId'];
var CHAT_HEADING_CONFIG = exports.CHAT_HEADING_CONFIG = ['chatHeadingConfig'];
var POP_OPEN_WELCOME_MESSAGE = exports.POP_OPEN_WELCOME_MESSAGE = ['popOpenWelcomeMessage'];
var POP_OPEN_WIDGET = exports.POP_OPEN_WIDGET = ['popOpenWidget'];
var POP_MESSAGE_ON_SMALL_SCREENS = exports.POP_MESSAGE_ON_SMALL_SCREENS = ['popMessageOnSmallScreens'];
var SHOW_ON_SMALL_SCREENS = exports.SHOW_ON_SMALL_SCREENS = ['showOnSmallScreens'];
var LANGUAGE = exports.LANGUAGE = ['language'];
var CLIENT_TRIGGERS = exports.CLIENT_TRIGGERS = ['clientTriggers'];